export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  bm.add('pattern', {
    label: 'Pattern',
    category: 'Motif',
    content: {
      activeOnRender: 1,
      droppable: false,
      resizable: {
        step: 0.2,
        minDim: 3,
        currentUnit: 1,
        autoHeight: true,
      },
      void: true,
      type: 'pattern',
      style: {
        width: '50%',
        height: '50%',
      },
    },
    attributes: {
      class: 'icon-Shape', //icon in the panel
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/pattern/blocks.js